module.exports = __webpack_public_path__ + "img/CF_2V.2.b70a3dba.jpg";